import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  cssVariables: true,

  /* =====================================================
     PALETTE (JS-SAFE ONLY — NO CSS VARS HERE)
     ===================================================== */
  palette: {
    primary: {
      main: "#0f1111",
    },
    text: {
      primary: "#3b5457",
      secondary: "#546e6f",
    },
    divider: "#e5eaea",
    background: {
      default: "#f9fbfc",
      paper: "#ffffff",
    },
  },

  /* =====================================================
     TYPOGRAPHY (CSS VARIABLES ARE SAFE HERE)
     ===================================================== */
  typography: {
    fontFamily: '"Crimson Pro", serif',
  },

  shape: {
    borderRadius: 8,
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1300,
      xl: 1536,
    },
  },

  /* =====================================================
     COMPONENTS (CSS VARIABLES SAFE)
     ===================================================== */
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        },
      },
    },
  },
});

export default theme;
